export const SEARCH_DETAILS_PAGE_KEY = 'page';
export const SEARCH_DETAILS_PAGE_NUMBER_KEY = 'page_number';
export const SEARCH_DETAILS_PER_PAGE_KEY = 'per_page';
export const SEARCH_DETAILS_QUERY_KEY = 'query';
export const SEARCH_DETAILS_ORDERING_KEY = 'ordering';
export const FILTER_BY_ROLES_KEY = 'role';
export const FILTER_BY_PARTNERSHIP_PROGRAMS_KEY = 'partnership';
export const FILTER_BY_PARTNER_TYPES_KEY = 'type';
export const FILTER_BY_ANNOUNCEMENT_CATEGORIES_KEY = 'announcement_c';

export const SEARCH_DETAILS_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  AGENTS: 'Agents',
  PARTNERS: 'Partners',
  BRAND: 'Brand',
  AIR_TEAM: 'Air Team',
  AGENCY: 'Agency',
  COMMISSIONS: 'Commissions',
  CLIENTS: 'Guest Writer',
  SEO_CONSULTANTS: 'SEO Consultant',
  SUPPORT_STAFF: 'Support Staff',
} as const;

export const SEARCH_DETAILS_PARTNERSHIP_PROGRAMS = {
  SMARTFLYER_ELEVATE: 'smartflyer elevate',
  PREFERRED_PARTNER: 'preferred partner',
  SMARTFLYER_RECOMMENDS: 'smartflyer recommends',
} as const;

export const PARTNERSHIP_PROGRAMS_MAP = [
  { id: '1', value: SEARCH_DETAILS_PARTNERSHIP_PROGRAMS.SMARTFLYER_ELEVATE, label: 'Elevate' },
  { id: '2', value: SEARCH_DETAILS_PARTNERSHIP_PROGRAMS.PREFERRED_PARTNER, label: 'Preferred Partner' },
  { id: '3', value: SEARCH_DETAILS_PARTNERSHIP_PROGRAMS.SMARTFLYER_RECOMMENDS, label: 'Smartflyer Recommends' },
];

export const SEARCH_DETAILS_PARTNER_TYPES = {
  BRAND: 'brand',
  CRUISE_LINE: 'cruise_line',
  HOTEL: 'hotel',
  ONSITE: 'onsite',
} as const;

export const PARTNER_TYPES_MAP = [
  { id: '1', type: 'brand', label: '🏷️ Brand', filterLabel: 'Brand', icon: '🏷️' },
  { id: '2', type: 'cruise_line', label: '🚢 Cruise Line', filterLabel: 'Cruise Line', icon: '🚢' },
  { id: '3', type: 'hotel', label: '🏨 Hotel', filterLabel: 'Hotel', icon: '🏨' },
  { id: '4', type: 'onsite', label: '📍 Onsite', filterLabel: 'Onsite', icon: '📍' },
];

export const PARTNERS_TYPES_LABELS = {
  HOTEL: '🏨 Hotel',
  CRUISE_LINE: '🚢 Cruise Line',
  BRAND: '🏷️ Brand',
  ONSITE: '📍 Onsite',
} as const;

export type SearchDetailsRolesType = (typeof SEARCH_DETAILS_ROLES)[keyof typeof SEARCH_DETAILS_ROLES];
export type SearchDetailsPartnershipProgramsType =
  (typeof SEARCH_DETAILS_PARTNERSHIP_PROGRAMS)[keyof typeof SEARCH_DETAILS_PARTNERSHIP_PROGRAMS];
export type SearchDetailsPartnerTypesType =
  (typeof SEARCH_DETAILS_PARTNER_TYPES)[keyof typeof SEARCH_DETAILS_PARTNER_TYPES];
